import queryString from "query-string";

import { SALE_STATUS } from "constants/actionTypes";

import { URLCreatorProps } from "actions/types";
import { serializeSaleStatus } from "lib/serializers/saleStatus";

import { offlineActionCreator, urlCheckAndAddIdAndAction } from "./lib";

const urlCreator = ({ changesSince, id, action }: URLCreatorProps = {}) =>
  queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction("/v2/sale-status/", id, action),
    query: {
      changesSince,
    },
  });

export const SaleStatusAction = offlineActionCreator(
  SALE_STATUS,
  serializeSaleStatus,
  urlCreator,
  false,
);
